// components/receptionist/RejectAppointmentModal.jsx - UPDATE

import React from "react";
import { useSanitizedInput } from "../../hooks/useSanitizedInput";

const RejectAppointmentModal = ({ show, onHide, onReject, loading }) => {
  const [rejectReason, handleReasonChange, resetReason] = useSanitizedInput('', 'text');

  const handleSubmit = () => {
    onReject(rejectReason);
    resetReason();
  };

  if (!show) return null;

  return (
    <div className="modal show d-block" style={{ background: "rgba(0,0,0,0.5)" }}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content" style={{ borderRadius: "16px", border: "none" }}>
          <div
            className="modal-header"
            style={{
              background: "linear-gradient(135deg, #dc3545 0%, #c82333 100%)",
              color: "white",
              borderRadius: "16px 16px 0 0",
            }}
          >
            <h5 className="modal-title fw-bold">Reject Appointment</h5>
            <button
              type="button"
              className="btn-close btn-close-white"
              onClick={onHide}
            ></button>
          </div>
          <div className="modal-body p-4">
            <div className="mb-3">
              <label className="form-label fw-semibold">Reason for Rejection</label>
              <textarea
                className="form-control"
                rows="4"
                value={rejectReason}
                onChange={handleReasonChange}
                placeholder="Enter reason..."
                style={{ borderRadius: "10px" }}
                maxLength="500"
              ></textarea>
              <small className="text-muted">{rejectReason.length}/500 characters</small>
            </div>
          </div>
          <div className="modal-footer">
            <button
              className="btn btn-secondary"
              onClick={onHide}
              style={{ borderRadius: "10px" }}
            >
              Cancel
            </button>
            <button
              className="btn btn-danger"
              onClick={handleSubmit}
              disabled={loading || !rejectReason.trim()}
              style={{ borderRadius: "10px" }}
            >
              Reject Appointment
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RejectAppointmentModal;